import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login/Login'
import Register from '@/components/Login/Register'
import ResetPass from '@/components/Login/ResetPass'
import Home from '@/components/Home/Home'
import Atenciones from '@/components/Atenciones/Atenciones'
import DeviceLostInfo from '@/components/LostMyPhone/DeviceLostInfo'
import Planes from '@/components/Planes/Planes'
import Tracking from '@/components/Tracking/Tracking'
import Sales from '@/components/Sales/Index'
import Cookie from '@/components/Cookie'
import StoreRedirect from '@/components/StoreRedirect'

import userStore from '../stores/user.js'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/cookie',
			name: 'Cookie',
			component: Cookie
		},
		{
			path: '/login',
			name: 'Login',
			component: Login
		},
		{
			path: '/register',
			component: Register,
			hidden: true,
			name: 'Register'
		},
		{
			path: '/resetpass/:token',
			component: ResetPass,
			hidden: true,
			name: 'Reestablecer',
			meta: {
				title: 'Reestablecer Contraseña'
			}
		},
		{
			path: '/',
			name: 'Home',
			component: Home
		},
		{
			path: '/atenciones',
			name: 'Atenciones',
			component: Atenciones
		},
		{
			path: '/device-info',
			name: 'Information',
			component: DeviceLostInfo
		},
		{
			path: '/planes',
			name: 'Planes',
			component: Planes
		},
		{
			path: '/tracking',
			name: 'Tracking',
			component: Tracking
		},
		{
			path: '/sales',
			name: 'Sales',
			component: Sales
		},
		{
			path: '/store-redirect',
			name: 'StoreRedirect',
			component: StoreRedirect
		},
	]
})

router.beforeEach((to, from, next) => {
	if (to.name !== 'Cookie' && to.name !== 'Login'  && to.name !== 'StoreRedirect'  && to.name !== 'Register' && to.name !== 'Reestablecer' && to.name !== 'Alert' && !userStore.state.isAuthenticated) next({ name: 'Login' })
	else if ((to.name === 'Login') && userStore.state.isAuthenticated) next({ name: 'Home' })
	else next()
})

export default router
